import type { SVGProps } from "react";
import { forwardRef } from "react";
import type { Ref } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgHomeSearch = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    focusable="false"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M6.785 21h10.43a3.32 3.32 0 0 0 3.323-3.322v-7.174c0-.89-.401-1.734-1.092-2.298l-5.574-4.54a2.964 2.964 0 0 0-3.743 0l-5.574 4.54a2.97 2.97 0 0 0-1.092 2.299v7.173A3.32 3.32 0 0 0 6.785 21"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="m15.113 16.725-1.5-1.5m-.001 0a2.768 2.768 0 1 1-3.915-3.914 2.768 2.768 0 0 1 3.915 3.914"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgHomeSearch);
export default ForwardRef;
